import React from 'react';

import Header from './header';
import Footer from './footer';

import '../styles/layout.css';

const Layout = ({children, showLogin, hideNav}) => (
  <>
    <Header showLogin={showLogin} hideNav={hideNav} />
    {children}
    <Footer />
  </>
);

export default Layout;
